import { render } from "./CompetitiveGroupsSection.vue?vue&type=template&id=36fa49e0"
import script from "./CompetitiveGroupsSection.vue?vue&type=script&lang=js"
export * from "./CompetitiveGroupsSection.vue?vue&type=script&lang=js"

import "./CompetitiveGroupsSection.vue?vue&type=style&index=0&id=36fa49e0&lang=css"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__